import React from "react";
import {
  Flex,
  Segment,
  Button,
  Provider,
} from "@fluentui/react-northstar";
import ImageTitleContainer from "../ImageTitleContainer";
import Constants from "../../../constants/text-constants";
import LocationsImage from "../../../assets/images/undraw_calling_kpbp.svg";
import TeamsCallingLocationForm from "../../molecules/Forms/TeamsCallLocationForm";
import { observer } from "mobx-react-lite";
import PropTypes from "prop-types";
import { useMst } from "../../../hooks/useMst";
import LocationHandler from "../../../services/api/locationHandler";

const TeamsCallingLocation = observer((props) => {
  const { teamsCallingLocationComplete } = props;
  const { locationStore, permissionStore } = useMst();

  let hasPermissions = permissionStore.havePermissions("Custom Values", [
    "Get",
    "Set",
  ]);

  const onSaveMSTeamsLocation = async (location) => {
    try {
      let sortedLocations = locationStore.locations.slice().sort((a, b) => {
        return a.code.localeCompare(b.code);
      });
      let missingLocations = Array.from(Array(99), (v, i) => {
        let value = i + 1;
        return value.toString().padStart(2, "0"); // convert to string and pad with '0'
      }).filter((i) => !sortedLocations.some((loc) => loc.code === i));

      if (missingLocations.length === 0) {
        return false;
      }

      let newCode = missingLocations[0];
      location.code = newCode.toString();

      await LocationHandler.createNewLocation(location);

      // Add location to store
      locationStore.addLocation(location);

      teamsCallingLocationComplete();
      return true;
    } catch (err) {
      return false;
    }
  };

  const onSkip = () => {
    if (teamsCallingLocationComplete) {
      teamsCallingLocationComplete();
    }
  };

  const skipButton = hasPermissions ? (
    <Button
      className="skip-button"
      text
      size="small"
      data-testid="teamsCallingLocationSkipButton"
      onClick={onSkip}
      content={Constants.SKIP}
    />
  ) : null;

  const bgClass = "page full-screen";
  const bgClassSegment = "teams-calling-location-container segment";

  return (
    <Provider.Consumer
      render={(theme) => (
        <Flex
          className={
            theme.siteVariables.themeString === "default"
              ? bgClass + " bg-onboarding default"
              : bgClass
          }
          data-testid="teamsCallingLocation"
          column
        >
          <Segment
            className={
              theme.siteVariables.themeString === "dark"
                ? bgClassSegment + " dark"
                : bgClassSegment
            }
            data-testid="teamsCallingLocationSegment"
          >
            <Flex className="teams-calling-location-container-flex">
              <ImageTitleContainer
                image={LocationsImage}
                title={Constants.ADD_CALLING_LOCATION_TITLE}
                subTitle={Constants.ADD_CALLING_LOCATION_SUBTITLE}
                testId="teamsCallingLocationContainer"
              >
                <Flex className="teams-calling-location-container-flex-form">
                  <TeamsCallingLocationForm onSave={onSaveMSTeamsLocation} />
                </Flex>
              </ImageTitleContainer>
            </Flex>
            {skipButton}
          </Segment>
        </Flex>
      )}
    ></Provider.Consumer>
  );
});

TeamsCallingLocation.propTypes = {
  teamsCallingLocationComplete: PropTypes.func,
};

export default TeamsCallingLocation;
